<template>
  <div class="login-section">
    <el-dialog
      custom-class="custom-dialog"
      title="请先登录"
      :visible.sync="showLogin"
      width="30%"
      :before-close="handleClose"
    >
      <div class="login-form">
        <el-form
          ref="form"
          :model="form"
          label-width="80px"
          label-position="left"
        >
          <el-form-item label="账号:">
            <el-input v-model="form.name" />
          </el-form-item>
          <el-form-item label="密码:" label-position="left">
            <el-input v-model="form.password" show-password />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="login-button"
          type="primary"
          :loading="loading"
          @click="onClickLogin"
        >登 录</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { RES_SUCCESS_CODE } from '@/constances/server.js'
import { login, getInfo } from '@/api/user.js'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      loading: false,
      form: {
        name: process.env.NODE_ENV === 'development'?'经销商测试号2':'',
        password: process.env.NODE_ENV === 'development'?'12345678':'',
      }
    }
  },

  computed: {
    ...mapGetters(['showLogin'])
  },

  watch: {
    async $route(to, from) {
      if (to.meta.power) {
        const token = this.$cookies.get('Admin-Token')
        if (!token) {
          await this.$store.dispatch('user/openLogin', {
            value: true
          })
        }
      }
    }
  },

  created() {
    console.log(this.visible)
  },

  methods: {
    async handleClose() {
      await this.$store.dispatch('user/openLogin', {
        value: false
      })
    },

    onClickLogin() {
      this.loading = true
      this.$store.dispatch('user/login', this.form).then((res) => {
        this.loading = false
        this.form.name = ''
        this.form.password = ''
        getInfo().then((res) => {
          // console.log(res)
          if (res.code === RES_SUCCESS_CODE) {
            this.$store.commit('user/SET_USER_INFO', {
              name: res.data.name,
              code: res.data.customer_number,
              role_id: res.data.role_id
            })
            // console.log(this.$cookies.get('url'))
            this.$router.push({
              path: this.$cookies.get('url')
            })
            this.$cookies.set('url', '')
          }
        })
      })

      this.loading = false

      /* login(this.form).then(async (res) => {
        if (res.code === RES_SUCCESS_CODE) {
          await this.$store.dispatch('user/openLogin', {
            value: false
          })

        } else {
          this.$message.error(res.message)
        }
      }) */
    }
  }
}
</script>

<style lang="scss" scope>
.custom-dialog {
  .el-dialog__headerbtn {
    &:hover {
      .el-dialog__close {
        color: #bc9783 !important;
      }
    }
  }
}

.login-form {
  width: 70%;
  margin: 0 auto;
  .el-form-item__label {
    color: #bc9783;
  }
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  .login-button {
    background-color: #bc9783;
    border-color: #bc9783;
  }
}
</style>
